import * as request from '@/utils/request'
import { getLevel } from '@/utils/chat/chatUtil';

let api = '';


// 收藏知识图谱
// params: {kgid: ''}
export const collectGraph = (params) => request.post(api + '/collectKg', { ...params, level: getLevel() });

// 移除收藏
// params: {kgid: '不等式-0'}
export const removeGraph = (params) => request.post(api + '/RemoveKg', { ...params, level: getLevel() })

// 展示知识图谱名称列表
// return {kgnames: ['不等式-0', '不等式-3']}
export const showGraphNames = () => request.post(api + '/showKgNames', { level: getLevel() })

// 展示知识图谱详情
// params: {kgid: '不等式-0'}
export const showGraph = (params) => request.post(api + '/showKg', params)